import script from "./ImagePopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImagePopover.vue?vue&type=script&lang=ts&setup=true"

import "./ImagePopover.vue?vue&type=style&index=0&id=39ae56a1&lang=scss"

const __exports__ = script;

export default __exports__